module.exports = __webpack_public_path__ + "img/beaumarchais.b55f1ee6.jpg";